// Models
import { MultipleDaysOrDatesRecurrenceCalculator } from "./MultipleDaysOrDatesRecurrenceCalculator";
// Utilities
import { Temporal } from "temporal-polyfill-lite";
/**
 * Represents a weekly recurrence pattern calculator.
 * @example Tuesday of every 2nd week. (Weekly)
 */ export class WeeklyRecurrenceCalculator extends MultipleDaysOrDatesRecurrenceCalculator {
    isSameOrBefore(start, end) {
        const startOffset = start.dayOfWeek % 7;
        const endOffset = end.dayOfWeek % 7;
        // Set to beginning of the week (Sunday) then check. This is because we iterate through the weeks
        return Temporal.PlainDate.compare(start.subtract({
            days: startOffset
        }), end.subtract({
            days: endOffset
        })) <= 0;
    }
    getDurationBetweenDateAndPatternStartDate(date) {
        // Set to beginning of week and return number of whole weeks between
        const dateOffset = date.dayOfWeek % 7;
        const patternStartDateOffset = this.patternStartDate.dayOfWeek % 7;
        return date.subtract({
            days: dateOffset
        }).since(this.patternStartDate.subtract({
            days: patternStartDateOffset
        }), {
            largestUnit: "weeks"
        }).weeks;
    }
    constructor(schedule, patternStartDateAsInstant, occurrenceIndex){
        super(schedule, patternStartDateAsInstant, occurrenceIndex, {
            weeks: 1
        });
    }
}
